import { CSSProperties } from 'styled-components';
import { colors } from '../../assets/colors';
import styled from 'styled-components';

type Props = {
    className?: string;
    i: string | number;
    fontWeight?: string;
    color?: string;
    small?: boolean;
    large?: boolean;
    header?: boolean;
    style?: CSSProperties;
};

const StyledText = styled.p<{
    $color?: string;
    $fontWeight?: string;
    $small?: boolean;
    $large?: boolean;
    $header?: boolean;
}>`
    color: ${(props) => props.$color || colors.dark};
    font-weight: ${(props) => props.$fontWeight || ''};
    font-size: ${(props) => {
        if (props.$small) return '14px';
        if (props.$large) return '18px';
        if (props.$header) return '24px';
        return '16px';
    }};

    /* Responsive font sizes matching GlobalStyle breakpoints */
    @media screen and (max-width: 768px) {
        font-size: ${(props) => {
            if (props.$small) return '13px';
            if (props.$large) return '16px';
            if (props.$header) return '20px';
            return '15px';
        }};
    }

    @media screen and (max-width: 480px) {
        font-size: ${(props) => {
            if (props.$small) return '12px';
            if (props.$large) return '14px';
            if (props.$header) return '18px';
            return '14px';
        }};
    }
`;

const Text = ({ className, i, fontWeight, color, small, large, header, style }: Props) => {
    return (
        <StyledText
            className={className}
            $color={color}
            $fontWeight={fontWeight}
            $small={small}
            $large={large}
            $header={header}
            style={style}>
            {i}
        </StyledText>
    );
};

export default Text;
